var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRejected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FD2828",
    d: "M9 0C4.037 0 0 4.038 0 9c0 4.963 4.038 9 9 9s9-4.037 9-9c0-4.962-4.038-9-9-9m0 1.64c1.734 0 3.33.603 4.59 1.61L3.25 13.59A7.33 7.33 0 0 1 1.64 9C1.64 4.942 4.94 1.64 9 1.64m0 14.72a7.32 7.32 0 0 1-4.59-1.61L14.75 4.41A7.33 7.33 0 0 1 16.36 9c0 4.059-3.302 7.36-7.36 7.36"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h18v18H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejected);
export default __webpack_public_path__ + "static/media/rejected.3851a3941210a3d655293a0b4ede6a68.svg";
export { ForwardRef as ReactComponent };